// src/App.tsx
import { useState } from "react";
import { Box } from "@mui/material";

import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";

interface Section {
  id: string;
  label: string;
}

const App = () => {
  const [activeSection, setActiveSection] = useState<string>("home");

  // Define sections for navigation
  const sections: Section[] = [
    { id: "home", label: "Startsida" },
    { id: "about", label: "Information" },
    { id: "services", label: "Tjänster" },
    { id: "contact", label: "Kontakt" },
  ];

  return (
    // Give this Box the containerId used by scroller
    <Box
      id="ContainerElementID"
      sx={{ height: "100vh", width: "100%", overflowY: "scroll" }}
    >
      <Header
        sections={sections}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      <Hero />
      <About />
      <Services />
      <Contact />
    </Box>
  );
};

export default App;
